import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section 
      id="home" 
      className="hero-section"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.3)',
          zIndex: 1
        }}
      />
      
      <Container style={{ position: 'relative', zIndex: 2 }}>
        <Row className="align-items-center">
          <Col lg={6} data-aos="fade-right">
            <h1 
              className="display-4 fw-bold text-white mb-4"
              style={{ fontSize: '3.5rem' }}
            >
              Welcome to Altogroup
            </h1>
            <p 
              className="lead text-white mb-4"
              style={{ fontSize: '1.25rem' }}
            >
              Leading the future of digital transformation through innovative marketing strategies and cutting-edge app development solutions.
            </p>
            <div className="d-flex gap-3 flex-wrap">
              <Button 
                variant="primary" 
                size="lg"
                onClick={() => scrollToSection('services')}
                style={{
                  background: 'linear-gradient(45deg, #007bff, #0056b3)',
                  border: 'none',
                  padding: '12px 30px',
                  fontWeight: '600',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 5px 15px rgba(0, 123, 255, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                Our Services
              </Button>
              <Button 
                variant="outline-light" 
                size="lg"
                onClick={() => scrollToSection('about')}
                style={{
                  padding: '12px 30px',
                  fontWeight: '600',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                Learn More
              </Button>
            </div>
          </Col>
          
          <Col lg={6} className="text-center" data-aos="fade-left">
            <div 
              className="hero-image"
              style={{
                animation: 'float 3s ease-in-out infinite'
              }}
            >
              <i 
                className="fas fa-rocket text-primary"
                style={{ fontSize: '8rem' }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
